<script lang="ts" setup>
    import type { TrainingCourseDetail } from '~/types/academy/baseTraining';
    import { sanitizeHtml } from '~/utils/sanitizeHtml';

    defineProps<{
        isLoading?: boolean;
        training?: TrainingCourseDetail;
    }>();
</script>

<template>
    <template v-if="isLoading">
        <div
            class="text loading-text"
            aria-hidden="true"
        >
            <div class="loading-skeleton --slim-margin --line"></div>
            <div class="loading-skeleton --slim-margin --line"></div>
            <div class="loading-skeleton --slim-margin --line --short"></div>
            <div class="loading-skeleton --slim-margin --line"></div>
            <div class="loading-skeleton --slim-margin --line --medium"></div>
        </div>
        <div class="card-container">
            <aside
                class="loading-card"
                aria-hidden="true"
            >
                <div class="loading-skeleton --slim-margin --subheadline"></div>
                <div class="loading-skeleton --slim-margin --line"></div>
                <div class="loading-skeleton --slim-margin --line --medium"></div>
                <div class="loading-skeleton --slim-margin loading-button"></div>
            </aside>
        </div>
    </template>

    <template v-else-if="training">
        <!-- eslint-disable vue/no-v-html -->
        <div
            class="text"
            v-html="sanitizeHtml(training.description)"
        ></div>
        <!-- eslint-enable vue/no-v-html -->
        <div class="card-container">
            <AcademyTrainingCtaCard :training="training" />
        </div>
    </template>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/basics/loading-skeleton.scss';
    @import '~/assets/scss/text/text.scss';

    .loading-card {
        position: relative;
        align-self: start;
        background: $white;
        border-radius: $border-radius-s;
        box-shadow: 0 4px 10px rgba($black, 0.25);
        display: flex;
        flex-direction: column;
        gap: $spacing;
        padding: $spacing--2 $spacing;
        width: 100%;
    }

    .loading-skeleton.--short {
        width: 55%;
    }

    .loading-skeleton.--medium {
        width: 70%;
    }

    .loading-button {
        height: 2.5rem;
        margin-bottom: 0;
        width: 100%;
    }
</style>
